import { useTranslation } from "react-i18next";
import { CurrencyCode } from "@/types";
import { formatNumber, getCurrencyLabel } from "./utils";

/** Number, money and unit formatting for the modal, in the user's language. */
export const useInspectionFormat = () => {
  const { t, i18n } = useTranslation();

  // Listed out (not built from the code) so the i18n extractor sees every key.
  const deviationUnitLabels: Record<string, string> = {
    PPO: t("inspections:units.PPO"),
    PM: t("inspections:units.PM"),
    PS: t("inspections:units.PS"),
    PH: t("inspections:units.PH"),
    PK: t("inspections:units.PK"),
    PT: t("inspections:units.PT"),
  };

  const number = (value: number, options?: Parameters<typeof formatNumber>[2]) =>
    formatNumber(value, i18n.language, options);

  return {
    number,
    /** "1 110 kr" */
    amount: (value: number, currency: CurrencyCode, options?: Parameters<typeof formatNumber>[2]) =>
      `${number(value, options)} ${getCurrencyLabel(currency)}`,
    /** "kr 0,40/kg"; `fixed` off gives "kr 950/t" for whole prices. */
    unitPrice: (price: number, currency: CurrencyCode, unit: string, fixed = true) =>
      `${getCurrencyLabel(currency)} ${number(price, { fixed })}/${unit}`,
    /** The short unit of a deviation's registered number, by unit code (PT → "tonn", PS → "stk" …). */
    deviationUnit: (unitCode: string | null | undefined) => deviationUnitLabels[unitCode ?? ""] ?? "",
  };
};
